module.exports = __webpack_public_path__ + "static/media/Societe-Direction-Travaux-Vaud.3193b17e.jpg";